import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const CreditsIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M10,9.29c-.39,0-.71.32-.71.71s.32.71.71.71.71-.32.71-.71-.32-.71-.71-.71Z" />
  <path d="M.71,2.86h18.57c.24,0,.46-.12.6-.32.22-.33.13-.77-.2-.99L17.54.12c-.33-.22-.77-.13-.99.2s-.13.77.2.99l.18.12H.71C.32,1.43,0,1.75,0,2.14s.32.71.71.71Z" />
  <path d="M19.28,17.14H.71c-.39,0-.71.32-.71.71,0,.24.12.46.32.59l2.14,1.43c.33.22.77.13.99-.2.22-.33.13-.77-.2-.99l-.18-.12h16.21c.39,0,.71-.32.71-.71s-.32-.71-.71-.71Z" />
  <path d="M16.01,5.51c-.58.12-1.16.19-1.75.2-1.37.04-2.73-.18-4.01-.67-2.32-.88-4.86-1.01-7.26-.36-.93.26-1.57,1.1-1.56,2.06v5.64c0,.14.01.29.04.43.24,1.16,1.36,1.9,2.52,1.67,1.92-.39,3.92-.23,5.75.46,1.33.51,2.75.77,4.18.77.13,0,.26,0,.38,0,.91-.03,1.82-.17,2.7-.4.93-.26,1.57-1.1,1.56-2.06v-5.64c0-.64-.29-1.26-.79-1.66-.5-.41-1.15-.57-1.78-.44ZM5,10c0,.39-.32.71-.71.71s-.71-.32-.71-.71v-1.43c0-.39.32-.71.71-.71s.71.32.71.71v1.43ZM10,12.14c-1.18,0-2.14-.96-2.14-2.14s.96-2.14,2.14-2.14,2.14.96,2.14,2.14-.96,2.14-2.14,2.14ZM16.43,11.43c0,.39-.32.71-.71.71s-.71-.32-.71-.71v-1.43c0-.39.32-.71.71-.71s.71.32.71.71v1.43Z" />
 </svg>,
 "Credits"
);
